/*=========================================================================================
  File Name: module-send-to-developer-mutations.js
  Description: SendToDeveloper Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import Vue from 'vue';
import defaultState from './module-send-to-developer-state';

export default {};
